import { useSyncExternalStore } from 'react'
import { useTranslation } from 'react-i18next'

function subscribe(callback: () => void): () => void {
  window.addEventListener('online', callback)
  window.addEventListener('offline', callback)
  return () => {
    window.removeEventListener('online', callback)
    window.removeEventListener('offline', callback)
  }
}

function getSnapshot(): boolean {
  return navigator.onLine
}

export function OfflineIndicator() {
  const { t } = useTranslation()
  const isOnline = useSyncExternalStore(subscribe, getSnapshot)

  if (isOnline) return null

  return (
    <div className="bg-coral text-coral-foreground fixed top-0 right-0 left-0 z-50 px-4 py-1.5 text-center text-sm font-medium">
      {t('offline.message', "You're offline. Changes will sync when connected.")}
    </div>
  )
}
